(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("4ti9D", function(module, exports) {
document.querySelectorAll(".base-header__toggle").forEach((toggle)=>{
    const togglers = toggle.querySelectorAll(".base-header__toggle-button");
    togglers.forEach((togglerButton)=>{
        togglerButton.addEventListener("click", ()=>{
            toggle.classList.toggle("--open");
        });
    });
});

});

})();
//# sourceMappingURL=base-header--toggle.6d71235e.js.map
